import GetShopArticleTaxByIdRequestModelBase from '../_generated/modelBases/get-shop-article-tax-by-id-request-model-base';

export default class GetShopArticleTaxByIdRequestModel extends GetShopArticleTaxByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
